import React, { Component } from 'react';
import Text from './../../Global/Modules/Text'

class Toelatingseisen extends Component {

  render() {
    return (
      <Text url='/info/rcro' />
    );
  }
}

export default Toelatingseisen;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Rc-ro-rt-worden.js